import jwtDecode from "jwt-decode";
import moment from "moment";

export const removeEmptyProperties = obj => {
  const newObj = {};

  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === "object") {
      newObj[key] = removeEmptyProperties(obj[key]); // recurse
    } else if (obj[key] != null) {
      newObj[key] = obj[key]; // copy value
    }
  });

  return newObj;
};

export function remainingTokenTime(token) {
  if (!!token) {
    const decoded = jwtDecode(token);
    if (!!decoded) {
      const remaining_milliseconds = decoded.exp * 1000 - new Date().getTime();
      return remaining_milliseconds;
    }
  }
  // Max negative time
  return new Date(0).getTime() - new Date().getTime();
}

export const centsToDollars = cents => {
  try {
    return (Number(cents) / 100).toFixed(2);
  } catch {
    return cents;
  }
};

export function oneTimeFormat(date) {
  return moment(date).format("MMMM Do YYYY, h:mm:ss a");
}

export function oneCalenderFormat(date) {
  return moment(date).calendar();
}

export function keepKeys(obj, keys) {
  const newObj = {}
  Object.keys(obj).forEach(key => {
    if (keys.includes(key)) {
      newObj[key] = obj[key]
    }
  })
  return newObj
}

export const __DEV__ = process.env.NODE_ENV === "development";
